import AdminLogin from "../admin/AdminLogin";
import ApplicationForms from "../admin/ApplicationForms";
import ContactForms from "../admin/ContactForms";
import QuoteRequests from "../admin/QuoteRequests";
import ShippingCalculations from "../admin/ShippingCalculations";
import About from "../pages/About";
import Contact from "../pages/Contact";
import ApplyJob from "../pages/employment/apply/ApplyJob";
import Success from "../pages/employment/apply/Success";
import Employment from "../pages/employment/Employment";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import RequestQuote from "../pages/RequestQuote";
import Services from "../pages/Services";

export const publicRoutes = [
  {
    name: "Not Found",
    path: "*",
    page: NotFound,
  },
  {
    name: "Home",
    path: "/",
    page: Home,
  },
  {
    name: "About",
    path: "/about",
    page: About,
  },
  {
    name: "Services",
    path: "/services",
    page: About,
  },
  {
    name: "Employment",
    path: "/employment",
    page: Employment,
  },
  {
    name: "Apply Job",
    path: "/employment/apply",
    page: ApplyJob,
  },
  {
    name: "Success",
    path: "/employment/form-success",
    page: Success,
  },
  {
    name: "Contact",
    path: "/contact-us",
    page: Contact,
  },
  {
    name: "Request Quote",
    path: "/request-quote",
    page: RequestQuote,
  },
  {
    name: "Admin Login",
    path: "/shah-login",
    page: AdminLogin,
  },
];

export const privateRoutes = [
  {
    name: "Applications",
    path: "/shah-admin/applications",
    page: ApplicationForms,
  },
  {
    name: "Contact Forms",
    path: "/shah-admin/contact-requests",
    page: ContactForms,
  },
  {
    name: "Qoute Requests",
    path: "/shah-admin/quote-requests",
    page: QuoteRequests,
  },
  {
    name: "Shipping Calculations",
    path: "/shah-admin/shipping-calculations",
    page: ShippingCalculations,
  },
];
